export const syncTags = (context) => (id, apply) => ({
    type: "CMS.INTEGRATIONS.SYNC_TAGS",
    payload: { id, apply },
    context,
});

export const updateConfiguration = (context) => (id) => ({
    type: "CMS.INTEGRATIONS.UPDATE_CONFIGURATION",
    payload: { id },
    context,
});

export const syncData = (context) => (id) => ({
    type: "CMS.INTEGRATIONS.SYNC_DATA",
    payload: { id },
    context,
});

export const runSyncTask = (context) => (id, type) => ({
    type: "CMS.INTEGRATIONS.SYNC_TASK_RUN",
    payload: { id, type },
    context,
});
